<template>
  <q-page class="q-ma-md">
    <q-form>
      <PageHeader
        title="Criar Permissão"
        :backRoute="{ name: 'home' }"
        backBehavior="route"
      />
      <div class="row q-gutter-sm items-center">
        <div class="col-lg-3 col-md-4 col-xs-12 text-brand-5 text-weight-bold">
          Nome
          <q-input v-model="nomePermissao" type="text" dense outlined />
        </div>
        <div class="col-lg-1 col-md-2 col-xs-12">
          <p></p>
          <q-btn
            color="positive"
            icon="add"
            class="full-width"
            label="Criar"
            @click.prevent="criar"
            no-caps
            size="md"
          />
        </div>
        <div class="col-lg-2 col-md-2 col-xs-12">
          <p></p>
          <q-btn
            color="secondary"
            icon="refresh"
            class="full-width"
            label="Sincrozinar Permissões"
            :loading="sincronizarLoading"
            @click="sincronizarPermissoes"
            no-caps
            size="md"
          />
        </div>
      </div>
    </q-form>
    <div>
      <q-table
        class="tabela-tamanho-fixo q-mt-md"
        table-header-class="bg-accent text-width-bold"
        :rows="listaPermissoes"
        :columns="columns"
        row-key="name"
        dense
        hide-pagination
        v-model:pagination="pagination"
        flat
        no-data-label="Exemplo"
        :loading="loading"
        :rows-per-page-options="[0]"
      >
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";
const columns = [
  {
    name: "permissao",
    label: "Permissão",
    field: (row) => row.permissao,
    align: "left",
  },
];
export default {
  components: { PageHeader },
  setup() {
    const store = useStore();
    let nomePermissao = ref();
    const $q = useQuasar();
    const listaPermissoes = ref([]);
    let loading = ref(true);
    const sincronizarLoading = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 400,
      rowsNumber: 15,
    });

    let criar = async () => {
      try {
        await store.dispatch("office/criarPermissao", {
          nome: nomePermissao.value,
        });
        listar();
        nomePermissao.value = "";
        $q.notify({
          type: "positive",
          message: "Permissão Criada com Sucesso",
          position: "top",
        });
      } catch (error) {
        console.log(error);
        $q.notify({
          type: "negative",
          message: "Falha ao Criar Permissão",
          position: "top",
        });
      }
    };

    let listar = async () => {
      let response = await store.dispatch("office/listarPermissoes");

      listaPermissoes.value = response.data.resultado.dados;
      loading.value = false;
    };

    const sincronizarPermissoes = async () => {
      try {
        await store.dispatch("office/sincronizarPermissoesNew");

        $q.notify({
          type: "positive",
          message: "Permissãos Sincronizadas com Sucesso",
          position: "top",
        });
        listar();
        sincronizarLoading.value = false;
      } catch (error) {
        sincronizarLoading.value = false;
        $q.notify({
          type: "negative",
          message: "Falha ao Sincronizar Permissão",
          position: "top",
        });
      }
    };

    onMounted(listar);

    return {
      nomePermissao,
      criar,
      listar,
      columns,
      listaPermissoes,
      loading,
      pagination,
      sincronizarPermissoes,
      sincronizarLoading,
    };
  },
};
</script>
